

const getDateInMs = (d) => {
  let secOrMillisec = d;
  if (Math.abs(Date.now() - secOrMillisec) > Math.abs(Date.now() - secOrMillisec * 1000)) {
    secOrMillisec *= 1000;
  }
  return secOrMillisec;
}

const getDateDisplayStr = (d) => {
  try {
    const date = new Date(d);
    const str = date.toLocaleDateString("en-US", { day: 'numeric' }) + 	" " + 
      date.toLocaleDateString("en-US", { month: 'short' }) + 	", " + 
      date.toLocaleDateString("en-US", { year: 'numeric' });
    return str;
  }
  catch (error) {}
}

const edgeTransformer = (edgeData) => {

  const edge = { ...edgeData };

  // Ensure date fields are in milliseconds and add date display strings
  // if (entity[ATTR_LAST_EDITED_TIME]) {
  //   entity[ATTR_LAST_EDITED_TIME] = getDateInMs(entity[ATTR_LAST_EDITED_TIME]);
  //   entity[ATTR_LAST_EDITED_TIME_STR] = getDateDisplayStr(entity[ATTR_LAST_EDITED_TIME]);
  // }

  // Return transformed entity
  return edge;

}

export default edgeTransformer;